import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import * as S from '../../Form/DateInput/styled'

const DateFilter = ({ label, column, onApplyFilters, gotoPage, state, selectedFilters = [] }) => {
    const [dateToFilter, setDateToFilter] = useState(null)

    const path = window.location.pathname
    const claims = window.localStorage.getItem('claims')
    const user = claims ? JSON.parse(claims)['id'] : ''

    useEffect(() => {
        let storedFilters = JSON.parse(window.localStorage.getItem(`${user}_filterValues${path}`))

        if (storedFilters && storedFilters[column.id]) {
            column.setFilter(storedFilters[column.id])
            setDateToFilter(new Date(storedFilters[column.id]))
        }
    }, [])

    useEffect(() => {
        if (dateToFilter) {
            column.setFilter(dateToFilter.toISOString())
        }
    }, [dateToFilter])

    useEffect(() => {
        // Clear filters on reset
        if (Object.keys(state[0].filters).length === 0) {
            setDateToFilter(null)
        }
    }, [state[0].filters])

    function handleBlur() {
        if (dateToFilter) {
            onApplyFilters()
            gotoPage(0)
        }
    }

    return (
        <>
            {selectedFilters[column.id] && (
                <S.DatePickerInput className="form-group !mb-2 lg:!mb-0 lg:!mr-2">
                    <label>{label}</label>
                    <S.DatePickerContainer className="form-row">
                        <div className="col-12">
                            <DatePicker
                                className="datepicker__start-date form-control"
                                placeholderText="Select Date..."
                                dateFormat="dd/MM/yyyy"
                                selected={dateToFilter}
                                onChange={date => setDateToFilter(date)}
                                onBlur={handleBlur}
                            />
                        </div>
                    </S.DatePickerContainer>
                </S.DatePickerInput>
            )}
        </>
    )
}

DateFilter.propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    column: PropTypes.shape({
        filterValue: PropTypes.object,
        setFilter: PropTypes.func.isRequired,
    }),
    onApplyFilters: PropTypes.func.isRequired,
}

export default DateFilter
